import { Controller } from 'stimulus';

const TOGGLE_CLASS = 'u-displayNone';
const LIMIT_TIME_S = 10;

class OpportunityExportLimiterController extends Controller {
  static targets = ['exportButton', 'limitMessage'];

  initialize() {
    this.timeRemainingSeconds = 0;
    this.currentTimeout = null;
  }

  disableExport() {
    this.exportButtonTarget.classList.add(TOGGLE_CLASS);
    this.timeRemainingSeconds = LIMIT_TIME_S;
    this._setLimitMessage();
    this.limitMessageTarget.classList.remove(TOGGLE_CLASS);
    this._doTimer();
  }

  _enableExport() {
    this.exportButtonTarget.classList.remove(TOGGLE_CLASS);
    this.limitMessageTarget.classList.add(TOGGLE_CLASS);
    this.timeRemainingSeconds = 0;
  }

  _doTimer() {
    setTimeout(() => {
      this.timeRemainingSeconds--;
      this._setLimitMessage();

      if (this.timeRemainingSeconds > 0) {
        this._doTimer();
      } else {
        this._enableExport();
      }
    }, 1000);
  }

  _setLimitMessage() {
    this.limitMessageTarget.innerHTML = `You may export again in <span>${this.timeRemainingSeconds}</span>`;
  }
}

export default OpportunityExportLimiterController;
